import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const TimezoneConverter = (props) => {
  const { time, style, format = "datetime" } = props;
  // format: "date" | "time" | "datetime"

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || {},
  );

  const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [timeZone, setTimezone] = useState(defaultTimezone);

  useEffect(() => {
    const newTimezone = currentProject?.timeZone || defaultTimezone;

    setTimezone((prev) => (prev !== newTimezone ? newTimezone : prev));
  }, [currentProject?.timeZone]);

  const convertTimeToTimezone = (time) => {
    if (!time) return "";

    let options = {
      timeZone: timeZone,
    };

    if (format === "date") {
      options = {
        ...options,
        year: "numeric",
        month: "long",
        day: "numeric",
      };
    } else if (format === "time") {
      options = {
        ...options,
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
    } else {
      // default = datetime
      options = {
        ...options,
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
    }

    return new Date(time).toLocaleString("en-US", options);
  };

  const convertedTime = convertTimeToTimezone(time);

  return <span style={style}>{convertedTime}</span>;
};

export default TimezoneConverter;
